<template>
  <div class="c-select-account">
    <Row :gutter="12">
      <Col span="12">
        <group-box v-model="keyword" :data="data" :level="1" title="账号" class="c-account" @on-select="selectAll">
          <group-item :data="data" :keyword="keyword" @on-child="selectItem" @on-select="selectAll" />
        </group-box>
      </Col>

      <Col span="6" offset="1" class-name="m-result">
        <div class="m-wrap m-box" v-if="Boolean(value.length)">
          <group-box :title="`已选账号 (${value.length})`" result>
            <div v-for="item in value" :key="item.id" class="c-pop-tip">
              <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
            </div>
          </group-box>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, getKeyOfData } from '@/common/js/utils'
import GroupBox from './group-box'
import GroupItem from './group-item'
export default {
  name: 'selectAccount',
  components: { GroupBox, GroupItem },
  props: {
    value: {
      type: Array,
      required: true
    },
    data: {
      type: Array
    }
  },
  methods: {
    selectAll({ level, check, cat }) {
      this.data.forEach((ret) => {
        this.$set(ret, 'check', check)
      })
    },
    handleClose(event, id) {
      const item = getKeyOfData(this.data, 'id', id)
      if (isArray(item.children) && item.children.length) {
        this.$emit('on-select', { list: this.data, check: false, current: id })
      } else {
        this.$set(item, 'check', false)
      }
    },
    selectItem({ current }) {
      const index = this.data.findIndex((ret) => ret.id === current)
      this.$set(this.data[index], 'check', true)
    }
  },
  data() {
    return {
      keyword: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-account {
  width: 100%;

  .c-account {
    border: 1px solid #e8eaec;
  }

  .m-result {
    min-width: 320px;

    .m-wrap {
      border: 1px solid #e8eaec;
    }

    ::v-deep .c-content {
      height: 412px;
    }

    .c-pop-tip {
      width: 100%;
    }

    .c-tag-item {
      width: 90%;
      margin: 8px 8px 0;
      padding: 2px 6px;
      display: block;
      font-size: 14px;
      height: 28px;
    }
  }
}
</style>
